export const DPA_URLS = {
  privacyInformation:
    'https://help.teachino.io/docs/datenschutz-ki-und-sicherheit/datenschutz-dsgvo',
  workflow: '/dpa/',
} as const;
